@if (tabs.length > 0) {
<nav class="payroll-tabs" [attr.aria-label]="groupLabel">
  <div class="ppl-nav ppl-nav-tabs">
    @for (tab of tabs; track tab.route) {
    <div class="ppl-nav-item">
      <a class="ppl-nav-link" [routerLink]="['/home', tab.route]" routerLinkActive="active"
        ariaCurrentWhenActive="page" (click)="onTabClick(tab)">{{ tab.label }}</a>
    </div>
    }
  </div>
</nav>
}
<router-outlet></router-outlet>
